import { handleCartError, handleApiResponseError } from '../utils/errorHandler';

/**
 * Shared mixin for add-to-cart functionality
 * Contains common methods used across all cart components
 */
export default {
  methods: {
    /**
     * Set cart count in store
     * @param {number} count - Cart item count
     */
    setCartCount(count) {
      this.$store.commit('wishlist/setCartCount', count);
    },

    /**
     * Calculate total quantity from cart response
     * @param {Array} lines - Cart line items
     * @returns {number} Total quantity
     */
    calculateTotalQuantity(lines) {
      return lines.reduce((sum, line) => sum + Number(line.quantity || 0), 0);
    },

    /**
     * Add items to cart
     * @param {Array} items - Array of cart items to add
     */
    addItemTocart(items) {
      if (items && items.length) {
        items.reverse();
      }
      
      this.isDisabled = true;
      const vm = this;

      const data = items.map(item => {
        // Apply quantity multiplier if set
        if (this.data && this.data.quantity) {
          item.qty = item.qty * this.data.quantity;
        }

        return item.isPackage
          ? this.ProductData(
              item.netSuiteId,
              item.qty,
              'NonInvtPart',
              item.hasPackages
            )
          : this.ProductData(item.netSuiteId, item.qty, 'Assembly', item.hasPackages);
      });

      jQuery
        .ajax({
          url: this.addToCartUrl,
          method: 'POST',
          data: JSON.stringify(data),
          xhrFields: {
            withCredentials: true
          }
        })
        .done(function(res) {
          if (handleApiResponseError(res, 'addToCart')) {
            vm.isDisabled = false;
            return;
          }

          const totalQty = vm.calculateTotalQuantity(res.lines || []);
          vm.setCartCount(totalQty);
          vm.isDisabled = false;
          vm.added = true;

          // Remove from wishlist if package
          if (items.length > 0 && items[0].isPackage) {
            vm.$emit('removeFromWishlist', vm.data.stockCode);
          }
        })
        .fail(function(err) {
          handleCartError(err, 'addToCart');
          vm.isDisabled = false;
        });
    },

    /**
     * Create product data object for NetSuite API
     * @param {string} netSuiteId - NetSuite item ID
     * @param {number} quantity - Item quantity
     * @param {string} type - Item type ('Assembly' or 'NonInvtPart')
     * @param {boolean} hasPackages - Whether item has packages
     * @returns {Object} Product data object
     */
    ProductData(netSuiteId = null, quantity = 1, type = 'Assembly', hasPackages = null) {
      const product = {
        internalid: netSuiteId || this.data.netSuiteId
      };
      product.type = type;

      const item = {
        item: product,
        quantity: quantity,
        options: hasPackages === true
          ? [
              {
                cartOptionId: 'custcol_rr_pmisca',
                itemOptionId: '',
                label: 'PMISCA',
                type: 'text',
                value: {
                  internalid: String(this.data.netSuiteParentId),
                  label: `"${this.data.netSuiteParentId}"`
                }
              }
            ]
          : [],
        location: '',
        fulfillmentChoice: 'ship',
        freeGift: false
      };

      return item;
    },

    /**
     * Get package components from API
     * @returns {Promise} Promise resolving to cart items array
     */
    async getPackageComponents() {
      try {
        const response = await jQuery.ajax({
          url: this.getPackageComponentsUrl,
          method: 'GET',
          xhrFields: {
            withCredentials: true
          }
        });

        if (!response.success) {
          throw new Error('Failed to get package components');
        }

        const cartItems = [];
        
        if (response.data.length) {
          // Package with components
          if (!this.data.netSuiteId) {
            throw new Error('Cannot add item: missing netSuiteId');
          }
          
          cartItems.push({
            netSuiteId: this.data.netSuiteId,
            qty: 1,
            isPackage: true,
            hasPackages: true
          });

          response.data.forEach(PackageComponent => {
            cartItems.push({
              netSuiteId: PackageComponent.netSuiteId,
              qty: PackageComponent.qty,
              isPackage: null,
              hasPackages: true
            });
          });
        } else {
          // Package without components
          if (!this.data.netSuiteId) {
            throw new Error('Cannot add item: missing netSuiteId');
          }
          
          cartItems.push({
            netSuiteId: this.data.netSuiteId,
            qty: 1,
            isPackage: true,
            hasPackages: false
          });
        }

        return cartItems;
      } catch (error) {
        handleCartError(error, 'getPackageComponents');
        this.isDisabled = false;
        throw error;
      }
    }
  },
  computed: {
    /**
     * Add to cart API URL
     */
    addToCartUrl() {
      return (
        this.netsuite_app_url +
        'services/LiveOrder.Line.Service.ss?c=' +
        (window.ns_session_var ? window.ns_session_var : '') +
        '&n=2'
      );
    },

    /**
     * Get package components API URL
     */
    getPackageComponentsUrl() {
      return (
        (window.culture ? '/' + window.culture : '') +
        '/api/getPackageComponents/' +
        this.data.productId
      );
    },

    /**
     * Button label based on state
     */
    buttonlabel() {
      return !this.added ? this.label_add_to_cart : this.label_added_to_cart;
    }
  }
};

